import { ButtonComp } from 'atoms/Buttons';
import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import * as Constants from '../Constants/ReorderConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const ReorderConfirmationModel = props => {
  const { onCancel, onContinue } = props;
  const { CONTINUE, CANCEL, ReorderConstants } = Constants;
  const { CLEAR_CART_MSG, CLEARE_AWARE_MSG, CLEAR_CART_COMPLETE_MSG } = ReorderConstants;
  const { CartError } = IMAGE_PATH;
  return (
    <div className='reorder-modal-container'>
      <div className='reorder-error-container'>
        <img src={CartError} alt='error-cart-icon' className='error-icon mb-3' />
        <div className='content-text' data-testid='contenttext-component'>
          <span>{translateWithI18Next(CLEARE_AWARE_MSG)}</span>
          <span className='red-text'>{translateWithI18Next(CLEAR_CART_MSG)}</span>
          <span>{translateWithI18Next(CLEAR_CART_COMPLETE_MSG)}</span>
        </div>
      </div>
      <div className='reorder-modal-btn'>
        <ButtonComp
          data-testid='confirmation-cancel-button'
          className='button whiteButton blackBorder closebtn-cls'
          onClick={onCancel}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          data-testid='continue-button'
          className='button blackButton blackBorder save-button'
          onClickHandler={onContinue}
        >
          {translateWithI18Next(CONTINUE)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default ReorderConfirmationModel;
